

























import { Component, Prop, Vue } from 'vue-property-decorator';
import { Utils } from '../../utils/utils';

@Component({
  components: {},
})
export default class SelectUser extends Vue {
  public dialog: boolean = true;
  private users: string[];
  public user: string = '';

  constructor() {
    super();
    this.users = Utils.getUsersName();
    let user: string = Utils.getCurrentUserName();
    if (user !== '') {
      this.dialog = false;
    }
  }

  public selectUser() {
    if (this.user !== '') {
      localStorage.setItem('user', this.user);
      this.dialog = false;
    }
  }
}
